export const enum BMotionLabel{
    LOOP,
    EASEIN,
    EASEOUT,
    FRAME,
    TWEEN
}